import React from 'react';
import { AntispoofingModelField } from '@models/prediction';
import { ConfigSection } from '@components/config/ConfigSection';
import RadioButtonList, { RadioButtonEntry } from '@components/config/radioButtonsList';
import styles from './antispoofingModelSection.module.scss';

interface Props {
    list: AntispoofingModelField[];
    value?: AntispoofingModelField;
    onChange: (value?: AntispoofingModelField) => void;
}

const AntispoofingModelSection: React.FC<Props> = ({
    list,
    value: selectedAntispoofingModelField,
    onChange,
}) => {
    const radioElements: RadioButtonEntry<AntispoofingModelField>[] = list.map((field) => {
        return { value: field, label: field };
    });
    const onValueChange = (element: AntispoofingModelField) =>
        onChange(element === selectedAntispoofingModelField ? undefined : element);

    // TODO AITOOL-8257 : When UKC button is updated , we have to remove this styling as we are overriding YOTI's styling which is a bad practice.
    return (
        <ConfigSection title="Antispoofing Model" className={styles['antispoofing-model-section']}>
            <RadioButtonList
                list={radioElements}
                selectedValue={selectedAntispoofingModelField}
                onChange={onValueChange}
            />
        </ConfigSection>
    );
};

export default AntispoofingModelSection;
